import { useEffect, useState } from "react";

export default function StatusBadge({ className = "" }) {
    // Jour affiche apres le montage : le HTML pre-rendu ne contient pas de jour fige.
    const [day, setDay] = useState("");
    useEffect(() => {
        setDay(new Date().toLocaleDateString("fr-FR", { weekday: "long" }).toUpperCase());
    }, []);
    return (
        <p
            data-testid="status-badge"
            className={`inline-flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.22em] text-green-400 ${className}`}
        >
            <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-60" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" />
            </span>
            Statut : Service actif<span data-status-day>{day ? ` · ${day}` : ""}</span>
        </p>
    );
}
